export type BrowserHandoffEnvironment = {
  isIframe: boolean;
  isMobile: boolean;
  isPrerendering: boolean;
};

export function getBrowserHandoffEnvironment(): BrowserHandoffEnvironment {
  const userAgent = window.navigator.userAgent;
  const isMobile =
    /Android|iPhone|iPad|iPod|IEMobile|Mobile/i.test(userAgent) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

  return {
    isIframe: window.self !== window.top,
    isMobile,
    isPrerendering: Boolean((document as Document & { prerendering?: boolean }).prerendering),
  };
}
